export default (...fs) => (x) => fs.reduceRight((acc, f) => f(acc), x)



// WEBPACK FOOTER //
// ./~/@klarna/ui/lib/compose.js